module.exports = __webpack_public_path__ + "static/4-aa7d8412bdd5b68be7997253ca3de9a3.jpg";